// Module
var code = "<div class=\"container container--narrow\">\n  <div class=\"wrap wrap-large\">\n    <div class=\"gap-large\">\n      <div class=\"gap-small\">\n        <span class=\"icon icon-spinner icon-spin loader-icon\"></span>\n      </div>\n      <div class=\"gap-small\"><slot>Loading, please wait...</slot></div>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;